import { NetworkStatus, useQuery } from '@apollo/client';
import { useEffect, useRef } from 'react';

export default function useGraphQuery(query, options = {}) {
  const retryRef = useRef();

  // ---------------------------------
  const { data, loading, error, refetch, networkStatus, fetching } = useQuery(query, {
    ...options,
    notifyOnNetworkStatusChange: true,
  });

  // ---------------------------------
  const retry = () => {
    retryRef.current = setTimeout(() => {
      refetch();

      setTimeout(() => {
        if (networkStatus === NetworkStatus.error && error?.networkError) {
          retry();
        }
      }, 5000);
    }, 2000);
  };

  // ---------------------------------
  useEffect(() => {
    if (networkStatus === NetworkStatus.error && error?.networkError) {
      retry();
    }

    return () => {
      if (retryRef.current) {
        clearTimeout(retryRef.current);
      }
    };
  }, [networkStatus]);

  // ---------------------------------
  return { data, loading, refetch, fetching: networkStatus === 4 };
}
